module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAUlJREFUWEft1b1KxEAUxfHf1mIrYqmIFloJ2oj4AWJla+0T+Ao+iVjYW4paqI21Yqug2IggCFpYiQ4kEsLMbpJdWIukzNy5559zz0w6hvx0hqyvBWgdaB34lw7MYgeHeBrQPbGIZRzhtdiz7MAkbjCKD2zjsk+IXRxkPR4wh6+8ZxlgCycFwRds4q4hRFE8bzGN+xTA2K/gNaYGABETv8I6vlMA4f1MZvt4HxAx8dvfvqt475aBfG0eZ2gCEUZ2WhpZVDzUdDuGMYhHrOA5kYkNHGchzkuS4r0AwnoMIiR5LQJRW7wKQFWImHgAXcJbtxNU9SZcwEXJ2tyJCZwn1lKj+mOqChA2pL5ypBTW1IiiRtQBSEEUG9cSr5qBMnnMiVBTW7wpQMyJRuL9AIS94Vbbxyf2Mgdq/zLqZqC2QK8NLUDrQOvA0B34AaHfSCHXxvq+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/04sportDesc/20down.png
// module id = USeJ
// module chunks = 0